import { IDENTITIES_KEYS } from '../types';
import { DEFAULT_GET_RULES } from './consts';
/**
 * Rules helpers
 */
export const rulesDefaults = (rules = {}) => (Object.assign(Object.assign({}, DEFAULT_GET_RULES), rules));
export const rulesDefaultsAll = (rules = {}, rulesGranular = {}) => {
    const output = {};
    for (const identificator in IDENTITIES_KEYS) {
        output[identificator] = rulesDefaults(Object.assign(Object.assign({}, rules), (rulesGranular[identificator] || {})));
    }
    return output;
};
